import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import Button from '@active/react-ui/Button'
import ButtonGroup from '@active/react-ui/ButtonGroup'
import { SavedCreditCardForm } from '../../../payments/components/CreditCard'
import PaymentAlias from '../../../payments/components/common/PaymentAlias'
import { paymentMethodPropType } from '../../../payments/components/common/paymentMethodTypes'
import I18nMessage from '../../../common/I18nMessage'
import { reduceFalseProp } from '../../../../shared/utils/commonUtils'
import '../wallet.components.scss'
import './EditCreditCard.scss'

class EditCriditCard extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,
    updateCreditCard: func.isRequired,
    setErrorMsg: func.isRequired,
    handleBackView: func.isRequired,
    updatePaymentInfoList: func.isRequired,
  }

  constructor(props) {
    super(props)
    const { paymentMethod } = this.props
    this.state = {
      displayName: paymentMethod && paymentMethod.displayName,
    }
  }

  getPaymentAliasCallBack = value => {
    this.setState({
      displayName: value,
    })
  }

  getSavedCreditCardCallBack = values => {
    const { displayName } = this.state
    const { updateCreditCard, setErrorMsg, updatePaymentInfoList } = this.props
    const {
      id, billingFirstName, billingLastName, cardHolderName = '', retentionDated, primary, address, expiredYear, expiredMonth,
    } = values
    const params = {
      postResource: 'wallet',
      id,
      address: reduceFalseProp({
        ...address,
        countryCode: address && address.country ? address.country : null,
      }),
      billingFirstName,
      billingLastName,
      displayName: displayName || null,
      primary,
      retentionDated,
      cardHolderName: cardHolderName.toUpperCase(),
      expiredYear,
      expiredMonth,
    }
    updateCreditCard({
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
      },
      params,
      resolve: res => {
        if (res.status === 'FAILURE') {
          setErrorMsg(res.message, res.errorCode)
        } else {
          updatePaymentInfoList(res)
          setErrorMsg(null, null, true)
        }
      },
      reject: ({ message, errorCode }) => {
        setErrorMsg(message, errorCode)
      },
    })
  }

  handleClick = () => {
    this.savedCreditCardForm()
  }

  handleCancel = () => {
    const { handleBackView } = this.props
    handleBackView()
  }

  render() {
    const { paymentMethod } = this.props
    const { displayName } = this.state
    const defaultValue = {
      displayName,
    }
    return (
      <div className="passport__wallet__save-creditcard passport__wallet__detail-component passport__wallet__components">
        <h1 className="passport__wallet__edit-creditcard__title passport__wallet__component-title">
          <I18nMessage id="passport.wallet.editCreditCard.title" />
        </h1>
        <I18nMessage id="passport.wallet.add.subtitle" className="passport__wallet__edit-creditcard__subtitle" />
        <SavedCreditCardForm
          paymentMethod={paymentMethod}
          submitTrigger={submitFunc => {
            this.savedCreditCardForm = submitFunc
          }}
          getSavedCreditCardCallBack={this.getSavedCreditCardCallBack}
        />
        <PaymentAlias getPaymentAliasCallBack={this.getPaymentAliasCallBack} defaultValue={defaultValue} />
        <ButtonGroup horizontal className="grid passport__wallet__btn">
          <Button type="primary" onClick={this.handleClick}>
            <I18nMessage id="passport.common.btn.update" />
          </Button>
          <Button type="secondary" onClick={this.handleCancel}>
            <I18nMessage id="passport.common.btn.cancel" />
          </Button>
        </ButtonGroup>
      </div>
    )
  }
}

export default EditCriditCard
